import { render, staticRenderFns } from "./industryAnalyze.vue?vue&type=template&id=213377d4&scoped=true"
import script from "./industryAnalyze.vue?vue&type=script&lang=js"
export * from "./industryAnalyze.vue?vue&type=script&lang=js"
import style0 from "./industryAnalyze.vue?vue&type=style&index=0&id=213377d4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213377d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('213377d4')) {
      api.createRecord('213377d4', component.options)
    } else {
      api.reload('213377d4', component.options)
    }
    module.hot.accept("./industryAnalyze.vue?vue&type=template&id=213377d4&scoped=true", function () {
      api.rerender('213377d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/industryChainNew/page/industryAnalyze.vue"
export default component.exports